<script>
const axios = require("@/state/axios.config").default;

import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { mapGetters } from "vuex";
import Paginate from "@/components/widgets/Paginate.vue";
import ICountUp from "vue-countup-v2";
import TreeChart from "./Vue-Tree.vue";

export default {
  page: {
    title: "Thành Viên",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Paginate, ICountUp, TreeChart },

  data() {
    return {
      options: {
        useEasing: true,
        useGrouping: true,
        separator: ",",
        decimal: ".",
        prefix: "",
        suffix: " VND",
        decimalPlaces: 0,
      },
      options2: {
        useEasing: true,
        useGrouping: true,
        separator: ",",
        decimal: ".",
        prefix: "",
        suffix: "",
        decimalPlaces: 0,
      },
      search: {
        user_id: "",
        user_email: "",
        User_Parent: "",
        page: 1,
      },
      title: "Thành viên",
      items: [
        {
          text: "Hệ thống",
          href: "/",
        },
        {
          text: "Thành Viên",
          active: true,
        },
      ],
      fields: [
        {
          key: "User_ID",
          sortable: false,
          label: "Mã Định Danh",
        },
        {
          key: "User_Email",
          sortable: false,
          label: "Email Người Dùng",
        },
        {
          key: "User_Parent",
          label: "Người Giới Thiệu",
        },
        {
          key: "f",
          label: "Tầng",
          sortable: false,
        },
        {
          key: "sum_total_inves_usd",
          label: "Tổng Đầu Tư",
          sortable: false,
        },
        {
          key: "User_RegisteredDatetime",
          label: "Ngày Đăng Ký",
        },
      ],
      currentPage: 1,
      totalPages: 10,
      tabsActive: "List",
      detail: {
        email: "",
        userID: "",
        totalInvested: 0,
        totalReceived: 0,
        totalMember: 0,
      },
      MemberTree: {},
      Statistical: {},
      isShowing: false,
    };
  },
  computed: {
    ...mapGetters({
      Member: "member/Member",
      UserInfo: "user/UserInfo",
      Rate: "wallet/Rate",
    }),
    url() {
      return `${window.location.hostname}/dang-ky?sponsor=${this.UserInfo.id}`;
    },
  },
  mounted() {
    this.onGetStatistical();
  },
  methods: {
    onCopy() {
      this.$toastr.s("Sao chép thành công");
    },
    onError() {
      this.$toastr.e("Sao chép Thất bại, vui lòng thử lại sau vài giây");
    },
    async onGetMemberTree() {
      const data = await axios.get("/api/v1/user/member/tree");
      this.MemberTree = data;
    },
    async onGetStatistical() {
      const data = await axios.get("/api/v1/user/member/agency-statictical");
      if (!data.Agency) {
        this.$router.push({ name: "default" });
        return;
      }
      this.isShowing = true;
      this.Statistical = data;
      this.onGetMemberTree();
    },
    async onGetMemberDetail(id) {
      const data = await axios.get("/api/v1/user/member/ajax-sale-user", {
        params: {
          user_id: id,
        },
      });
      console.log(data);
    },
    onSearch(type) {
      if (type === "reset") {
        this.search = {
          user_id: "",
          user_email: "",
          User_Parent: "",
          page: 1,
        };
      }
      this.$store.dispatch("member/req_getListMember", this.search);
    },
    onChangePage(payload) {
      this.search.page = payload;
      this.$store.dispatch("member/req_getListMember", this.search);
    },
    getTotalVolume({ vnd, usd }) {
      const totalUSD = parseFloat(usd) * parseFloat(this.Rate[10]);
      const totalVND = parseFloat(vnd);
      const volume = this.TruncateToDecimals(totalVND + totalUSD, "", 3);
      return volume;
    },
    clickNode(node) {
      console.log(node);
      this.onGetMemberDetail(node.id);
      this.modalDetail(
        node.id,
        node.name,
        // node.email,
        node.TotalDownlineInvestment,
        node.TotalDownlineRevenue,
        node.TotalMembers
      );
    },
    HideModal() {
      this.$bvModal.hide("infoTree");
    },
    clickChild(node) {
      if (node.lastF) {
        this.listMember = this.Member_2;
      }
    },
    modalDetail(ID, Name, email, totalInvested, totalReceived, totalMember) {
      this.detail.userID = ID;
      this.detail.name = Name;
      // this.detail.email = email;
      this.detail.totalInvested = totalInvested || 0;
      this.detail.totalReceived = totalReceived || 0;
      this.detail.totalMember = totalMember || 0;
      this.$bvModal.show("infoTree");
    },
  },
  created() {
    this.$store.dispatch("member/req_getListMember", this.search);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-container class="agency-page" v-if="isShowing">
      <b-row class="overflow-hidden py-4 justify-content-lg-around">
        <b-col cols="12" md="6" lg="6" xl="4" class="my-2" v-if="false">
          <div class="box-balance  ">
            <div class="box-title ">
              VÍ HOA HỒNG
            </div>
            <div class="box-body">
              <div class="box-main-balance">
                <div class="amount fw-medium text-black font-size-20">
                  <ICountUp :delay="2000" :endVal="0" :options="options" />
                </div>
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="12" md="6" lg="5" class="my-2">
          <b-row>
            <b-col cols="12" md="6" xl="12" class="my-2 ">
              <div class="box-balance second box-balance2  ">
                <div class="box-title ">
                  CẤP BẬC ĐẠI LÝ
                </div>
                <div class="box-body">
                  <div class="box-main-balance">
                    <div
                      class="amount fw-medium font-size-20"
                      v-if="Statistical.Agency != null"
                    >
                      {{ Statistical.Agency.user_agency_level_Name }}
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
            <b-col cols="12" md="6" xl="12" class="my-2 ">
              <div class="box-balance   second">
                <div class="box-title ">
                  TỔNG THÀNH VIÊN
                </div>
                <div class="box-body">
                  <div class="box-main-balance">
                    <div
                      class="amount fw-medium "
                      v-if="Statistical.TotalMembers != null"
                    >
                      <ICountUp
                        :delay="2000"
                        :endVal="Statistical.TotalMembers"
                        :options="options2"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>

        <b-col cols="12" lg="5">
          <b-row>
            <b-col cols="12" md="6" xl="12" class="my-2 ">
              <div class="box-balance second box-balance2  ">
                <div class="box-title ">
                  DOANH THU ĐÃ NHẬN CỦA THÀNH VIÊN
                </div>
                <div class="box-body">
                  <div class="box-main-balance">
                    <div
                      class="amount fw-medium "
                      v-if="Statistical.TotalDownlineRevenue != null"
                    >
                      <ICountUp
                        :delay="2000"
                        :endVal="Statistical.TotalDownlineRevenue"
                        :options="options"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
            <b-col cols="12" md="6" xl="12" class="my-2 ">
              <div class="box-balance   second">
                <div class="box-title ">
                  TỔNG ĐẦU TƯ CỦA THÀNH VIÊN
                </div>
                <div class="box-body">
                  <div class="box-main-balance">
                    <div
                      class="amount fw-medium "
                      v-if="Statistical.TotalDownlineInvestment != null"
                    >
                      <ICountUp
                        :delay="2000"
                        :endVal="Statistical.TotalDownlineInvestment"
                        :options="options"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-container class="box-title-nav">
        <div class="navbar-link">
          <a
            :class="{ active: tabsActive === 'List' }"
            @click="tabsActive = 'List'"
          >
            <div class="text">Danh Sách Tuyến Dưới</div>
          </a>
        </div>
        <div class="navbar-link">
          <a
            :class="{ active: tabsActive === 'Tree' }"
            @click="tabsActive = 'Tree'"
          >
            <div class="text">Cây Thành Viên</div>
          </a>
        </div>
      </b-container>
      <b-row class="mt-4">
        <b-col cols="12" v-if="tabsActive === 'List'">
          <div class="box-member">
            <!-- <div class="title">Danh Sách Thành Viên</div> -->
            <div class="box-table">
              <div class="table-search">
                <b-form-input
                  size="sm m-1"
                  placeholder="Mã Định Danh"
                  v-model.trim="search.user_id"
                ></b-form-input>
                <b-form-input
                  size="sm m-1"
                  placeholder="Email"
                  v-model.trim="search.user_email"
                ></b-form-input>
                <b-form-input
                  size="sm m-1"
                  placeholder="F.."
                  v-model.trim="search.User_Parent"
                ></b-form-input>
                <b-button
                  variant="success"
                  class="btn-egg btn-sm m-1"
                  @click="onSearch"
                >
                  Tìm Kiếm
                </b-button>
                <b-button
                  variant="danger"
                  class="btn-sm m-1"
                  @click="onSearch('reset')"
                >
                  Tải lại
                </b-button>
              </div>
              <div class="table-reponsive">
                <b-table striped hover :items="Member.list" :fields="fields">
                  <template #cell(f)="data"> F{{ data.item.f }} </template>
                  <template #cell(sum_total_inves_usd)="data">
                    {{
                      getTotalVolume({
                        usd: data.item.sum_total_inves_usd,
                        vnd: data.item.sum_total_inves_vnd,
                      })
                    }}
                    VND
                  </template>
                </b-table>
              </div>
              <div class="table-paginate">
                <Paginate @current="onChangePage" :totalPages="Member.total" />
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="12" v-if="tabsActive === 'Tree'">
          <div class="box-member-2 p-3">
            <TreeChart
              :json="MemberTree"
              @click-node="clickNode"
              @click-child="clickChild"
            />
          </div>
        </b-col>
      </b-row>
      <b-modal id="infoTree" hide-footer hide-header>
        <div class="title">
          <h3>
            Thông Tin Người Dùng
          </h3>
          <div class="close" @click="$bvModal.hide('modal-withdraw')">X</div>
        </div>
        <div class="grid grid-cols-12 gap-4 row-gap-3" style="padding:20px">
          <div class="col-span-12 xl:col-span-6">
            <label>Tên Đăng Nhập</label>
            <input
              v-model="detail.name"
              type="text"
              class="form-control border flex-1"
              readonly
            />
          </div>
          <!-- <div class="col-span-12 xl:col-span-6">
            <label>Email</label>
            <input
              v-model="detail.email"
              type="text"
              class="form-control border flex-1"
              readonly
            />
          </div> -->
          <div class="col-span-12 xl:col-span-6">
            <label>Mã Định Danh</label>
            <input
              v-model="detail.userID"
              type="text"
              class="form-control w-full border flex-1"
              readonly
            />
          </div>
          <div class="col-span-12 xl:col-span-6">
            <label>Tổng Đầu Tư</label>
            <input
              v-model="detail.totalInvested"
              type="text"
              class="form-control w-full border flex-1"
              readonly
            />
          </div>
          <div class="col-span-12 xl:col-span-6">
            <label>Tổng Doanh Thu</label>
            <input
              v-model="detail.totalReceived"
              type="text"
              class="form-control w-full border flex-1"
              readonly
            />
          </div>
          <div class="col-span-12 xl:col-span-6">
            <label>Tổng Thành Viên</label>
            <input
              v-model="detail.totalMember"
              type="text"
              class="form-control w-full border flex-1"
              readonly
            />
          </div>
        </div>
        <div
          class="px-5 py-3 text-center border-t border-gray-200 dark:border-dark-5 btn-infoTree"
          style="padding-bottom:20px"
        >
          <button
            type="button"
            class="button w-20 btn text-white"
            style="min-width:120px"
            @click="HideModal"
          >
            Cancel
          </button>
        </div>
      </b-modal>
    </b-container>
  </Layout>
</template>
<style lang="scss">
#infoTree {
  .close {
    color: #003395;
    font-weight: bold;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ccc;
    border-radius: 50%;
    padding: 5px;
    cursor: pointer;
  }
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    padding: 0 5px;
    min-height: 35px;
    border-radius: 5px;
    box-shadow: 5px 5px 5px 5px rgba(0, 0, 0, 0.349);
    h3 {
      color: #000;
      margin: 0;
    }
  }
  .form-group {
    max-width: 425px;
    margin: 15px auto;
    label {
      width: 100%;
      font-size: 17px;
      font-weight: 600;
      margin: 0px 0px 5px;
    }
    input.money-amount {
      width: 100%;
      border: 2px solid rgb(128, 128, 128);
      height: 40px;
      border-radius: 1px;
      font-size: 16px;
      font-weight: 700;

      padding: 0 10px;
    }
    .custom-checkbox {
      margin-top: 30px;
      display: flex;
      align-items: center;
      &.bg-white {
        input {
          background-color: #fff;
          border: 2px solid rgb(128, 128, 128);
        }
      }
      input {
        height: 30px;
        width: 30px;
      }
      label {
        margin: 0 5px;
      }
    }
    button {
      font-size: 17px;
      font-weight: 700;
    }
  }
  .form-control {
    background-color: #fff;
    border: 2px solid rgb(128, 128, 128);
    height: 40px;
    border-radius: 1px;
    font-size: 16px;
    font-weight: 600;
    &:hover,
    &:focus {
      color: #000;
    }
  }
  .text-pop {
    font-size: 18px;
    max-width: 425px;
    margin: 25px auto 10px;
    text-align: center;
    text-transform: capitalize;
    color: #fff !important;
    letter-spacing: 0.5px;
    span {
      font-weight: 700;
    }
  }
}
.agency-page {
  .box-balance {
    border: none;
    box-shadow: 0 5px 15px 1px rgb(0, 0, 0, 0.28);
    border-radius: 15px;
    background: linear-gradient(to top, #008cff, #ffffff);
    // min-height: 200px;
    height: 100%;
    width: 100%;
    max-width: 600px;
    border: 2px solid #00389b !important;
    &.second {
      background: linear-gradient(to bottom, #008cff, #003395);
      .box-title {
        color: #fff;
        &::after {
          content: "";
          width: 85%;
          height: 3px;
          background: #7fa3e2;
        }
      }
    }
    .box-title {
      padding: 10px;
      font-size: 1.4em;
      color: #000;
      text-align: left;
      font-weight: 700;
      position: relative;
      z-index: 10;
      // background-color: #240b59;
      border-top-left-radius: 15px;
      border-top-right-radius: 15px;
      padding-left: 10%;
      &::after {
        content: "";
        width: 85%;
        height: 3px;
        background: #00389b;
        position: absolute;
        bottom: 0;
        left: 5%;
        margin: auto;
      }
    }
    .box-body {
      padding: 10px;
      position: relative;
      z-index: 10;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      min-height: calc(100% - 60px);
      .box-main-balance,
      .box-main-received {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.2em;
        min-height: 70px;
        .name {
          margin: 10px 0;
          font-size: 20px;
          font-weight: bold;
          position: relative;
          z-index: 10;
        }
        .amount {
          margin: 10px 0;
          font-weight: bold;
          position: relative;
          z-index: 10;
          text-align: center;
          span {
            font-size: 24px;
          }
        }
        @media (max-width: 425px) {
          flex-direction: column;
        }
      }
      .button-group {
        display: flex;
        justify-content: space-around;
        align-items: center;
        flex-wrap: wrap;
        a,
        .btn {
          font-size: 16px;
          font-weight: 600;
          letter-spacing: 1px;
        }
        a {
          text-transform: uppercase;
        }
      }
    }
  }
  .box-title-nav {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 40px;
    padding: 0 0;
    min-height: 40px;
    background-color: #556ee6;
    border-radius: 10px;
    box-shadow: 0px 7px 10px 2px #00000038;
    .navbar-link {
      width: 100%;
      max-width: auto;
      min-width: 120px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      &:first-child {
        a {
          border-top-left-radius: 9px;
          border-bottom-left-radius: 9px;
        }
      }
      a {
        display: flex;
        width: 100%;
        height: 100%;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        text-decoration: none;
        &.active {
          border-bottom: 3px solid #ffff;
          background: linear-gradient(89deg, #00000075, #00000070);
        }

        .text {
          color: #fff;
          font-weight: 600;
          font-size: clamp(15px, 2vw, 17px);
          text-transform: uppercase;
        }
        .icon {
          img {
            height: 20px;
            width: auto;
          }
        }
      }
    }
  }
}
.box-member-2 {
  margin-bottom: 20px;
  border: none;
  box-shadow: 0 0.75rem 1.5rem rgba(0, 0, 0, 0.48);
  border-radius: 15px;
  background: linear-gradient(to bottom, #fff, #fff);
  border: 2px solid #00389b;
  min-height: 200px;
  width: 100%;
  overflow-x: auto;
}
.box-member {
  margin-bottom: 20px;
  border: none;
  box-shadow: 0 0.75rem 1.5rem rgba(0, 0, 0, 0.48);
  border-radius: 15px;
  background: linear-gradient(to bottom, #008cff, #003395);
  border: 2px solid #00389b;
  min-height: 200px;
  width: 100%;
  .title {
    font-weight: 600;
    font-size: 20px;
    color: #ffff;
    text-align: left;
    padding: 0 0 5px;
    text-transform: uppercase;
    width: 100%;
    padding: 5px 1.25rem;
  }
  .table-search {
    font-weight: 600;
    font-size: 20px;
    color: #fff;
    text-align: left;
    padding: 0 0 5px;
    border-top: 3px solid rgba($color: #000000, $alpha: 0.08);
    border-bottom: 3px solid rgba($color: #000000, $alpha: 0.08);
    text-transform: uppercase;
    width: 100%;
    min-height: 50px;
    padding: 5px 1.25rem;
    display: flex;
    flex-wrap: wrap;
    input {
      max-width: 225px;
    }
    select,
    input {
      border: 0;
      border-radius: 0;
      border-bottom: 2px solid #6c757d;
      background-color: #ffff;
      border-radius: 5px;
      height: 40px;
      font-size: clamp(15px, 1vw, 16.2px);
      font-weight: 600;
      position: relative;
      color: #000;
      &:focus {
        box-shadow: none;
        border-bottom: 2px solid #1b62f7;
      }
      &::placeholder {
        font-weight: 500;
        font-size: clamp(13px, 1vw, 15px);
      }
    }
    button {
      &.btn-egg {
        min-width: 105px;
        height: 40px;
      }
      width: auto;
      min-width: unset;
      font-weight: 600;
    }
    @media (max-width: 991px) {
      input {
        flex: 1;
        width: 50%;
      }
    }
    @media (max-width: 767px) {
      input {
        flex: unset;
        flex: 0 0 100%;
        max-width: unset;
      }
    }
  }
  .table-reponsive {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 10px 5px;
    table {
      width: 100%;
      border-radius: 10px;
      th,
      td {
        min-width: 100px;
        white-space: pre;
        padding: 5px 0.75rem;
      }
      thead {
        background: #1b62f7;
        border-radius: 10px;
        box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.1), 0 1px 0 0 rgba(0, 0, 0, 0.1);
        border: 0;
        color: #fff;
        font-weight: 600;
        tr {
          border-radius: 10px;
          th {
            border: 0;
            &:last-child {
              border-radius: 0px 10px 10px 0px;
            }
            &:first-child {
              border-radius: 10px 0 0 10px;
            }
          }
        }
      }
      tbody:before {
        content: "@";
        display: block;
        line-height: 10px;
        text-indent: -99999px;
      }
    }
  }
  .table-paginate {
    border-top: 3px solid rgba($color: #000000, $alpha: 0.08);
  }
}
.box-member-2 {
  .bg-primary.bg-soft {
    background: linear-gradient(to bottom, #008cff, #003395) !important;
  }
  .avatar {
    display: flex;
    justify-content: center;
    align-content: center;
    height: 100%;
    img {
      max-width: 140px;
      margin: auto;
      //   filter: drop-shadow(0px 0px 2px #ffffff7d);
    }
  }
  .img-fluid {
    height: 150px;
    width: auto;
  }
  .input-group-text {
    padding: 0;
  }
  .title {
    font-size: 1.2em;
    margin-top: 15px;
    color: #fff;
  }
  .input {
    margin-bottom: 15px;
    border: 1px solid #0d3dff75;
    border-radius: 5px;
    input {
      background-color: #ffff;
      color: #000;
      margin-left: -5px;
    }
  }
  .box-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    .top {
      color: #fff;
      font-size: 2em;
      font-weight: 600;
    }
    .bottom {
      font-size: 1.4em;
      color: #c3cbe4;
    }
  }
}
</style>
